import { Platform, Orientation } from "consts";

export const EmojiSize = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 25,
    [Orientation.LANDSCAPE]: 25,
  },
};

export const EmojiTopOffset = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: -120,
  },
};

export const EmojiLeftOffset = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 60,
  },
};
